import { render } from "./photoAlbum.vue?vue&type=template&id=11f974e8"
import script from "./photoAlbum.vue?vue&type=script&setup=true&lang=js"
export * from "./photoAlbum.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/photoAlbum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11f974e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11f974e8', __exports__)) {
    api.reload('11f974e8', __exports__)
  }
  
  module.hot.accept("./photoAlbum.vue?vue&type=template&id=11f974e8", () => {
    api.rerender('11f974e8', render)
  })

}


export default __exports__